//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['inuser'],
    data: function data() {
        return {
            user: this.inuser
        };
    },

    computed: {
        parseRoles: function parseRoles() {
            var output = [],
                self = this;

            this.roles.forEach(function (r, index) {
                output.push({
                    label: self.unslugify(r.name),
                    value: r.name
                });
            });

            return output;
        }
    },
    methods: {
        create: function create() {

            var self = this;

            window.axios.post('/new-user-register', this.user).then(function (response) {
                if (response.data) {
                    window.location = '/';
                }
            });
        }
    },
    mounted: function mounted() {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/users/UserRegister.vue
// module id = lhJ9
// module chunks = 0 1